import React from "react";
import { AutoClaimProcessingSection } from "./AutoClaimProcessingSection";
import { BasePriceSection } from "./BasePriceSection";
import { FraudNotificationSection } from "./FraudNotificationSection";
import { InactivePeriodsSection } from "./InactivePeriodsSection";
import { StopsToRemoveSection } from "./StopsToRemoveSection";
import { LinesToRemoveSection } from "./LinesToRemoveSection";
import { TicketSection } from "./TicketSection";

export const SettingsPage = () => {
  return (
    <React.Fragment>
      {/* <TicketSection /> */}
      <BasePriceSection />
      <AutoClaimProcessingSection />
      <LinesToRemoveSection />
      <StopsToRemoveSection />
      <InactivePeriodsSection />
      <FraudNotificationSection />
    </React.Fragment>
  );
};
